import { gql } from '../__generated__/gql';

export const GET_LOCATIONS_AND_COUNT = gql(`
  query GetLocationsAndCount(
    $orderBy: [LocationOrderByWithRelationInput!]
    $skip: Int
    $take: Int
    $where: LocationWhereInput
  ) {
    locations(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
      id
      name
    }

    aggregateLocation(where: $where) {
      count: _count {
        all: _all
      }
    }
  }
`);
